import React, { useState } from "react";
import { message } from "antd";

import COLOR from "utils/constants/color";
import styled from "styled-components";
import AnswerModal from "./AnswerModal";

import {
    Button,
    FormHelperText,
  
    Modal,
    TextareaAutosize
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
    CheckCircle,
    AccessTime
} from '@mui/icons-material';
import BadgeButton from '../BadgeButton';





const ModalContent = styled.div`
  left: 50%;
  max-width: 544px;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  min-height: 350px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px; 
    @media only screen and (max-width: 600px) {
        min-width: 90% !important;
    }
`;
const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: auto;
  margin-top: 10px;
`;
const LinkArea = styled.div`
  padding: 10px;
  margin: 2px;
  border: 1px dashed;
  margin-top: 24px;
`;
const TextAreaAuto = styled(TextareaAutosize)`
    height: 200px;
    width: 100%;
    border-radius: 2px;
    padding: 5px;
    overflow: auto;
    border-color: rgb(0 0 0 / 32%);
    ::focus-visible {
      outline: ${COLOR.green100}auto 1px !important;
     }
    ::focus{
      border-color: ${COLOR.green100} !important;
  }
`;
const TitleText = styled.span`
    font-size: 18px;
    color: black;
    font-weight:600;
    // margin-left:5px;
    // margin-top:5px;
`;
const CustomFormHelperText = styled(FormHelperText)`
 color:red !important;
  .MuiFormHelperText-root{
  color:red !important;
  }
`

const useStyles = makeStyles((theme) => ({
    formControl: {
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: '4px',
    },
}));
const PacingSyallabus = ({ bookId, pageId, teacherPage, onChangeAnswerDesc, teacherAnswerPageUpload, onCloseDrawer, onRemoveAnsPage, updateLoader, setUpdateLoader, loaderImg, setLoaderImg, hasPermission = true }) => {
    const [openModal, setOpenModal] = useState(false);
    return (<>
        <BadgeButton
            onClick={() => {
                if (!hasPermission) {
                    message.warning('You do not have permission to access this feature.');
                    return;
                }
                setOpenModal(true);
            }}
            startIcon={<AccessTime />}
            showBadge={teacherPage?.length > 0}
            backgroundColor="#059669"
        >
            Pacing Guide
        </BadgeButton>
           
        <Modal
            open={openModal}
            onClose={() => {setOpenModal(false)}}
            style={{ height: "100%", width: "100%" }}
        >
            <AnswerModal
                data={teacherPage}
                onChangeDesc={onChangeAnswerDesc}
                onChangeImage={teacherAnswerPageUpload}
                onCloseDrawer={() => {
                    onCloseDrawer()
                    setOpenModal(false)
                }}
                title={`Pacing Guide`}
                pageId={pageId}
                onRemove={onRemoveAnsPage}
                updateLoader={updateLoader}
                setUpdateLoader={setUpdateLoader}
                loaderImg={loaderImg}
                setLoaderImg={setLoaderImg}
                actionButtonText={`Add Image`}
            />
        </Modal>
    </>)
}

export default PacingSyallabus;